<template>
  <v-dialog
    v-model="isDialogOpen"
    max-width="680px"
    content-class="fixed-height-md"
  >
    <SetPhoneLine @close="isDialogOpen = false" @completed="$emit('finish')" />
  </v-dialog>
</template>

<script>
import SetPhoneLine from '@/views/settings/users/components/setPhoneLine/SetPhoneLine';

export default {
  name: 'SetupPhoneLineDialog',
  components: {
    SetPhoneLine,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDialogOpen: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
};
</script>
